export const PROMOTION_EVENTS = {
  OAUTH_REGISTERATION: "OAUTH_REGISTERATION",
  EMAIL_REGISTRATION: "EMAIL_REGISTRATION",
  WORKSPACE_SETTINGS: "WORKSPACE_SETTINGS",
};

export const SPECIAL_PROMO_CODES = {
  USER_REFERRAL: "USER_REFERRAL",
};
